/**
 * Admin Roles & Matrix Page (PR A8)
 */
import React from 'react';
import AdminRolesPage from './AdminRolesPage';

const AdminRoles = () => {
  return <AdminRolesPage />;
};

export default AdminRoles;
